import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 20a8 8 0 100-16 8 8 0 000 16zm.75-4.5V17h-1.5v-1.5h1.5zM10.5 10c0-.918.831-1.644 1.764-1.472h.006c.6.106 1.096.603 1.201 1.202v.001a1.502 1.502 0 01-.82 1.63 2.411 2.411 0 00-1.401 2.189V14h1.5v-.45a.91.91 0 01.532-.828l.01-.005a3.002 3.002 0 001.657-3.248 3.008 3.008 0 00-2.416-2.417C10.647 6.706 9 8.179 9 10h1.5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm.74-6V18h-1.5v-1.5h1.5zM9.75 9.75a2.25 2.25 0 012.657-2.212h.005a2.253 2.253 0 011.799 1.8v.002a2.246 2.246 0 01-1.242 2.442 3.005 3.005 0 00-1.719 2.708V15h1.5v-.51c0-.575.339-1.104.861-1.352A3.746 3.746 0 0015.69 9.08a3.753 3.753 0 00-3.018-3.02C10.309 5.638 8.25 7.466 8.25 9.75h1.5z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 45c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21zm1.48-12v3h-3v-3h3zM19.5 19.5a4.499 4.499 0 015.314-4.424l.01.002c1.795.311 3.286 1.803 3.598 3.598v.004c.378 2.145-.747 4.06-2.485 4.884A6.01 6.01 0 0022.5 28.98V30h3v-1.02a3.01 3.01 0 011.723-2.705 7.492 7.492 0 004.155-8.113c-.53-3.042-2.995-5.51-6.037-6.04-4.722-.846-8.841 2.81-8.841 7.378h3z",
    clipRule: "evenodd"
  }))
};
export var QuestionCircleFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});